module.exports = __webpack_public_path__ + "img/activity.a745ac56.png";